"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericSelectAllButton = void 0;
/*
 * © 2025 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const Button_1 = require("../Primitives/Button");
/** Generic Select All/Clear All button for filter popups */
const GenericSelectAllButton = ({ filterName, onSelectAll, onClearAll, isAllSelected = false, isNoneSelected = true, selectAllText, clearAllText, height = 30, width = 90, translationNamespace = "central-web-app-components", }) => {
    const { t } = (0, react_i18next_1.useTranslation)(translationNamespace);
    const handleSelectAll = (evt) => {
        if (onSelectAll) {
            onSelectAll(evt);
        }
        evt.stopPropagation();
    };
    const handleClearAll = (evt) => {
        if (onClearAll) {
            onClearAll(evt);
        }
        evt.stopPropagation();
    };
    // Show "Select All" if not all are selected, "Clear All" if some/all are selected
    const showSelectAll = !isAllSelected;
    const showClearAll = !isNoneSelected;
    if (showSelectAll) {
        return (react_1.default.createElement(Button_1.Button, { "data-testid": `filter-${filterName}-select-all`, key: "select-all", onClick: handleSelectAll, height: height, width: width }, selectAllText || t("button-Select All")));
    }
    if (showClearAll) {
        return (react_1.default.createElement(Button_1.Button, { "data-testid": `filter-${filterName}-uncheck-all`, key: "uncheck-all", onClick: handleClearAll, height: height, width: width }, clearAllText || t("button-Deselect All")));
    }
    // Fallback - should not happen with proper state management
    return (react_1.default.createElement(Button_1.Button, { "data-testid": `filter-${filterName}-check-all`, key: "check-all", onClick: handleSelectAll, height: height }, selectAllText || t("button-Select All")));
};
exports.GenericSelectAllButton = GenericSelectAllButton;
//# sourceMappingURL=GenericSelectAllButton.js.map